module.exports = __webpack_public_path__ + "static/WEDDING E&M-540-ef3f56475f4c7b46e6611d247d9d6fe6.jpg";